import React from 'react'

export default function CategoryLandingEditorModeToggle({
  title,
  description,
  mode,
  options,
  onChange,
  activeClassName = 'border border-brand-navy bg-sky-50 text-brand-navy ring-1 ring-brand-navy/10',
  inactiveClassName = 'border border-transparent bg-slate-100 text-slate-600 hover:bg-slate-200',
}) {
  return (
    <div className="rounded-xl border p-4 bg-white">
      <div className="flex items-center justify-between">
        <div>
          {title && <div className="text-sm font-semibold">{title}</div>}
          {description && <div className="text-xs text-slate-500 mt-1">{description}</div>}
        </div>
        <div className="flex items-center gap-2">
          {(options || []).map((option) => (
            <button
              key={option.value}
              type="button"
              className={`px-3 py-2 rounded text-sm font-semibold transition-colors ${mode === option.value ? activeClassName : inactiveClassName}`}
              onClick={() => onChange?.(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
